import { apiGet, apiPost, apiPut, apiDelete } from './client'
import type { ApiResponse } from '@crm/shared'
import type {
  CustomAction,
  CustomActionWithObject,
  CreateCustomActionRequest,
  UpdateCustomActionRequest,
  ActionLogWithUser,
  CreateActionLogRequest,
} from '@crm/shared'

export async function fetchCustomActions(objectId: string) {
  return apiGet<ApiResponse<CustomAction[]>>(`/objects/${objectId}/custom-actions`)
}

export async function fetchSettingsCustomActions(objectId?: string) {
  const params = objectId ? `?object_id=${objectId}` : ''
  return apiGet<ApiResponse<CustomActionWithObject[]>>(`/settings/custom-actions${params}`)
}

export async function createCustomAction(data: CreateCustomActionRequest) {
  return apiPost<ApiResponse<CustomActionWithObject>, CreateCustomActionRequest>('/settings/custom-actions', data)
}

export async function updateCustomAction(actionId: string, data: UpdateCustomActionRequest) {
  return apiPut<ApiResponse<CustomActionWithObject>, UpdateCustomActionRequest>(`/settings/custom-actions/${actionId}`, data)
}

export async function deleteCustomAction(actionId: string) {
  return apiDelete<ApiResponse<null>>(`/settings/custom-actions/${actionId}`)
}

export async function createActionLog(
  objectId: string,
  recordId: string,
  data: CreateActionLogRequest
) {
  return apiPost<ApiResponse<null>, CreateActionLogRequest>(
    `/objects/${objectId}/records/${recordId}/action-logs`,
    data
  )
}

export async function fetchActionLogs(params?: {
  object_id?: string
  record_id?: string
  custom_action_id?: string
  user_id?: string
  cursor?: string
  limit?: number
}) {
  const searchParams = new URLSearchParams()
  if (params?.object_id) searchParams.set('object_id', params.object_id)
  if (params?.record_id) searchParams.set('record_id', params.record_id)
  if (params?.custom_action_id) searchParams.set('custom_action_id', params.custom_action_id)
  if (params?.user_id) searchParams.set('user_id', params.user_id)
  if (params?.cursor) searchParams.set('cursor', params.cursor)
  if (params?.limit) searchParams.set('limit', String(params.limit))
  const qs = searchParams.toString()
  return apiGet<{ data: ActionLogWithUser[]; pagination: { next_cursor: string | null; has_more: boolean } }>(
    `/settings/action-logs${qs ? `?${qs}` : ''}`
  )
}
